import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// const hasPermission = (chkLevel, chkDepth) => {
  // const user = JSON.parse(sessionStorage.getItem('user'));
  // if (!user) return false;

  // 추후에 권한체크를 넣자
  // return user.level >= chkLevel && user.depth >= chkDepth;
// };

const RequireAuth = ({ children, chkLevel, chkDepth }) => {
  console.log('RequireAuth')
  const location = useLocation();
  const isAuthenticated = !!sessionStorage.getItem('adminSession'); // 로그인 여부 확인
  // if (!isAuthenticated || !hasPermission(chkLevel, chkDepth)) {
  if (!isAuthenticated) {
    const returnUrl = `${location.pathname}${location.search || ''}`;
    sessionStorage.setItem('adminReturnUrl', returnUrl);
    return <Navigate to="/Login" replace state={{ from: returnUrl }} />;
  }

  return children;
};

export default RequireAuth;
